import { useWatch } from 'react-hook-form';

import BrandingTabSplitLayout from 'components/BrandingTabSplitLayout/BrandingTabSplitLayout';
import { InputGroup, Textarea } from 'components/FormComponents';

import CandidateExperiencePreview from './CandidateExperiencePreview';

export const CandidateExperience = ({ hasVolunteer = false, register, control, brand }) => {
  const candidateIntroductionText = useWatch({ control, name: 'candidate_introduction_text' });

  return (
    <BrandingTabSplitLayout
      key={brand?.id}
      shellClassName="background-secondary"
      preview={
        <CandidateExperiencePreview
          brand={brand}
          showHeader={false}
          candidateIntroductionText={candidateIntroductionText}
        />
      }>
      <div className="flex flex-col gap-8">
        <section className="flex flex-col gap-8 rounded-3xl border border-neutral-4 bg-white p-6 shadow-sm">
          <InputGroup
            noMargin
            title="Candidate Introduction Text"
            description="Keep it short and concise. Maximum 500 characters.">
            <Textarea
              name="candidate_introduction_text"
              register={register}
              maxLength={500}
              placeholder="This system is a secure verification platform designed to simplify the process for employers and employees."
              inputProps={{ rows: 10 }}
            />
          </InputGroup>
        </section>
        {hasVolunteer && (
          <section className="flex flex-col gap-8 rounded-3xl border border-neutral-4 bg-white p-6 shadow-sm">
            <InputGroup
              title="Volunteer Introduction Text"
              description="Keep it short and concise. Maximum 500 characters."
              noMargin>
              <Textarea
                name="volunteer_introduction_text"
                register={register}
                maxLength={500}
                placeholder="This system is a secure verification platform designed to simplify the process for organisations and volunteers."
                inputProps={{ rows: 10 }}
              />
            </InputGroup>
          </section>
        )}
      </div>
    </BrandingTabSplitLayout>
  );
};
